import { render, staticRenderFns } from "./IFooter.vue?vue&type=template&id=6a2f0c83&scoped=true"
import script from "./IFooter.vue?vue&type=script&lang=js"
export * from "./IFooter.vue?vue&type=script&lang=js"
import style0 from "./IFooter.vue?vue&type=style&index=0&id=6a2f0c83&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f0c83",
  null
  
)

export default component.exports